module.exports = __webpack_public_path__ + "img/Laboratorio.949c1229.jpg";